import { render } from "./DestinationSetting.vue?vue&type=template&id=65e6a082&scoped=true"
import script from "./DestinationSetting.vue?vue&type=script&lang=js"
export * from "./DestinationSetting.vue?vue&type=script&lang=js"

import "./DestinationSetting.vue?vue&type=style&index=0&id=65e6a082&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e6a082"]])

export default __exports__